export default __webpack_public_path__ + "static/media/astro-min.3bfd10ad.webp";